export default function ReportsPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Reports</h1>
      <p className="text-slate-500">Reports placeholder</p>
    </div>
  );
}
